<template>
  <div class="manual-tools02-contents">
    <el-row>
      <el-col>
        <h2>プログラム情報登録<br class="sp-only">（AdCent）</h2>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <h4>
          【１】<a
            href="https://media.adcent.jp/login"
            target="_blank"
            rel="noopener noreferrer"
            >管理画面</a
          >にログインしたら、「LP一覧」をクリックします。
        </h4>
        <img :src="`${rt}/img/manual/google-cv/no05/no22/01.png`" alt="" />
        <h4>
          【２】登録したいプロモーション名を探して、「プロモーション名」をコピーします。
        </h4>
        <img :src="`${rt}/img/manual/google-cv/no05/no22/02.png`" alt="" />
        <p class="kokokara">
          --------------------------------<br class="sp-only">ここからアドタスカル<br class="sp-only">
          --------------------------------
        </p>
        <h4>【３】アドタスカルのASPプログラム名に貼り付けます。</h4>
        <div class="mini-img">
          <img :src="`${rt}/img/manual/google-cv/no05/no22/03.png`" alt="" />
        </div>
        <h4>【４】登録したいプロモーション名をAdCent担当者に連絡しプログラムIDを確認してください。</h4>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ManualGoogleCvContents",
  components: {
  },
  props: {},
  computed: {
    ...mapGetters(["rt", "tool", "tools"]),
  },
  methods: {},
  created() {
    this.$nextTick(() => {
      if (this.$route.hash !== "") {
        const hash = this.$route.hash;
        this.$scrollTo(hash, 0, {});
      }
    });
  },
};
</script>

<style lang="scss" scoped>
</style>
